<template>
    <div class="my-3" v-if="loaded">
        <div v-if="showEmpty" class="table-responsive">
            <template v-if="isMobile">
                <div v-for="recurrence in recurrences" :key="recurrence.id" class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">
                            <span>{{ recurrence.recurring_payment === null ?
                                $t('billing.recurrence.null_recurring_payment') : recurrence.recurring_payment}}</span>
                        </h5>
                        <p class="card-text">{{ recurrence.name }}</p>
                        <p class="card-text">{{ $moment(recurrence.due_date).format('DD/MM/YYYY') }}</p>
                        <p class="card-text">{{ recurrence.value }}</p>
                        <a :href="`/app/financial/recurrence/${recurrence.id}`" class="btn btn-success">
                            {{ $t('billing.recurrence.view') }}
                        </a>
                    </div>
                </div>
            </template>
            <template v-else>
                <!-- Mantém a tabela para desktop -->
                <table class="table align-items-center">
                    <thead class="thead-light">
                        <tr>
                            <th scope="col"># {{ $t('billing.recurrence.hash') }}</th>
                            <th scope="col">{{ $t('billing.recurrence.description') }}</th>
                            <th scope="col" data-sort="due_date" @click="onSort('due_date')">
                                {{ $t('billing.recurrence.due') }}</th>
                            <th scope="col" data-sort="value" @click="onSort('value')">{{ $t('common.value') }}</th>
                            <th class="text-center" scope="col">{{ $t('common.details') }}</th>
                        </tr>
                    </thead>
                    <tbody class="list">
                        <tr v-for="recurrence in recurrences" :key="recurrence.id">
                            <td>
                                <div v-if="recurrence.recurring_payment === null">
                                    {{ $t('billing.recurrence.null_recurring_payment') }}
                                </div>
                                <div v-else>
                                    {{ recurrence.recurring_payment }}
                                </div>
                            </td>
                            <td scope="row">
                                <div class="media align-items-center">
                                    <div class="media-body">
                                        <span class="name mb-0 text-sm">{{ recurrence.name }}</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div>
                                    {{ $moment(recurrence.due_date).format('DD/MM/YYYY') }}
                                </div>
                            </td>
                            <td class="budget">
                                {{ recurrence.value }}
                            </td>
                            <td class="text-center">
                                <a class="btn btn-success" :href="`/app/financial/recurrence/${recurrence.id}`"
                                    role="button">
                                    <span>{{ $t('billing.recurrence.view') }}</span>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </template>
            <div class="card-footer py-4">
                <div
                    class="pagination-container d-flex flex-column flex-md-row align-items-center justify-content-between">
                    <div class="pagination-info">
                        <span>{{ metaStatus }}</span>
                    </div>
                    <div class="pagination-buttons mt-3 mt-md-0">
                        <base-pagination class="mb-0" v-if="meta" :page-count="meta.last_page"
                            v-model="meta.current_page" @input="onChangePage" :visible-pages="isMobile ? 3 : 7"
                            type="#525F7F">
                        </base-pagination>
                    </div>
                </div>
            </div>
        </div>
        <Empty class="my-6" v-else :color="color" :icon="'fa-search-dollar'">
            <template #title><h1 class="font-weight-medium mb-0">{{ $t('empty.recurrence_title') }}</h1></template>
            <template #subtitle><p>{{ $t('empty.recurrence_subtitle') }}</p></template>
        </Empty>
    </div>
</template>


<script>
import BasePagination from '../../argon/components/BasePagination';
import Empty from '../Common/Empty';

export default {
    name: 'Recurrence',
    components: {
        BasePagination,
        Empty,
    },
    data() {
        return {
            invoices: null,
            data: {},
            perPage: 5,
            column: null,
            order: 'DESC',
            filters: [],
            statusDropdown: false,
            paymentDropdown: false,
            loaded: false,
            loadedMobile: false,
            isMobile: window.innerWidth < 1185,
        };
    },
    computed: {
        color() {
            return this.$store.getters.COLOR;
        },
        showEmpty() {
            if (this.recurrences && this.recurrences.length > 0) return true;
        },
        showEmptyInvoices() {
            if (this.invoices && this.invoices.length > 0) return true;
        },
        isTable() {
            if (this.$mq === 'lg') return true;
        },
        recurrences() {
            return this.data.data;
        },
        links() {
            return this.data.links;
        },
        meta() {
            return this.data.meta;
        },
        language() {
            return this.$store.getters.LANGUAGE;
        },
        metaStatus() {
            return this.meta ?
                ` ${this.$t('common.showing')} ${this.meta.from} ${this.$t('common.to')}
                ${this.meta.to} ${this.$t('common.of')} ${this.meta.total} ${this.$t('common.results')}` :
                '';
        },
        statusItems() {
            return [
                { name: 'Todos', value: -1, column: 'status' },
                { name: 'Ativo', value: 1, column: 'status' },
                { name: 'Inativo', value: 0, column: 'status' },
            ];
        },
        paymentItems() {
            return [
                { name: 'Todos', value: -1, column: 'payment_method' },
                ...this.payments,
            ];
        },
    },
    methods: {
        updateIsMobile() {
            this.isMobile = window.innerWidth < 1185;
        },
        getRecurrences() {
            this.$loading.show();
            window.axios
                .get(`/api/app/recurrences/${this.perPage}`, {
                    params: {
                        page: this.meta ? this.meta.current_page : 1,
                        column: this.column,
                        order: this.order,
                        filters: this.filters,
                    },
                })
                .then((res) => {
                    this.data = res.data;
                })
                .catch(err => console.error(err))
                .finally(() => {
                    this.$loading.close();
                    this.loaded = true;
                });
        },
        onChangePage(page) {
            this.meta.current_page = page;
            this.getRecurrences();
        },
        onSort(column) {
            this.column = column;
            this.order = this.order === 'DESC' ? 'ASC' : 'DESC';
            this.getRecurrences();
        },
        onFilter(item) {
            this.closeStatusDropdown();
            this.closePaymentDropdown();

            if (!this.filters.length) {
                this.filters.push(item);

                return this.getRecurrences();
            }

            const filters = this.filters.map((filter) => {
                if (filter.column === item.column) {
                    return item;
                }
                return filter;
            });

            this.filters = filters;
            this.getRecurrences();
        },
        closeStatusDropdown() {
            this.statusDropdown = false;
        },
        closePaymentDropdown() {
            this.paymentDropdown = false;
        },
    },
    mounted() {
        this.getRecurrences();
        window.addEventListener('resize', this.updateIsMobile);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.updateIsMobile);
    },
};
</script>

<style>
.card {
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
}
.card-body {
    padding: 1rem;
}
.card-title {
    margin-bottom: 0.75rem;
    font-size: 1.25rem;
}

.pagination-container {
    display: flex;
    flex-direction: column; /* Padrão: Coloca o texto acima dos botões */
    align-items: center;
}

.pagination-info {
    text-align: center; /* Centraliza o texto */
}

.pagination-buttons {
    width: 100%; /* Garante que os botões ocupem a largura total no mobile */
    display: flex;
    justify-content: center;
}

@media (min-width: 1185px) {
    .pagination-container {
        flex-direction: row; /* Em telas maiores, os elementos ficam lado a lado */
        justify-content: space-between;
    }

    .pagination-info {
        text-align: left;
    }

    .pagination-buttons {
        justify-content: flex-end;
    }
}

</style>
